import type { InjectionKey, ComputedRef, Ref } from 'vue'
import type { GameWinnerResponse } from './composables/UseGameWinners'

export type GameWinnerTileVariant = 'short' | 'long' | 'bingo'

export interface GameWinnerTileProps {
    winner: GameWinnerResponse
    isMegaPrize?: boolean
    isBigWin?: boolean
    variant?: GameWinnerTileVariant
    horizontal?: boolean
}

export interface GameWinnerTileKeyReturn {
    winner: Readonly<Ref<GameWinnerResponse>>
    icon: Ref<string>
    money: Ref<string | Intl.NumberFormatPart[]>
    wonTimeAgo: ComputedRef<string>
    isMegaPrize: Ref<boolean>
    isBingo: Ref<boolean>
    startGame: () => Promise<void>
}

export const gameWinnerTileKey = Symbol() as InjectionKey<GameWinnerTileKeyReturn>
